// Cliente do Better Auth (servidor em /api/auth). O app guarda o token da
// sessão nas configurações e manda como "Authorization: Bearer" (plugin bearer).

import { createAuthClient } from "better-auth/client";
import { emailOTPClient, adminClient } from "better-auth/client/plugins";
import { apiBase, apiToken } from "./api.js";

let client = null;
let clientBase = "";

export function authClient() {
  const base = apiBase();
  if (!client || clientBase !== base) {
    clientBase = base;
    client = createAuthClient({
      baseURL: base,
      basePath: "/api/auth",
      plugins: [emailOTPClient(), adminClient()],
      fetchOptions: {
        // Sem cookies: a sessão vai no cabeçalho Authorization.
        credentials: "omit",
        auth: { type: "Bearer", token: () => apiToken() || "" },
      },
    });
  }
  return client;
}

const MESSAGES = {
  INVALID_EMAIL_OR_PASSWORD: "E-mail ou senha incorretos.",
  EMAIL_NOT_VERIFIED: "Confirme seu e-mail com o código que enviamos.",
  USER_ALREADY_EXISTS: "Já existe uma conta com este e-mail.",
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "Já existe uma conta com este e-mail.",
  PASSWORD_TOO_SHORT: "A senha precisa ter pelo menos 8 caracteres.",
  INVALID_EMAIL: "E-mail inválido.",
  INVALID_OTP: "Código incorreto.",
  OTP_EXPIRED: "O código expirou. Peça um novo.",
  TOO_MANY_ATTEMPTS: "Muitas tentativas. Peça um novo código.",
  BANNED_USER: "Seu acesso ao Ordo foi bloqueado. Fale com quem administra.",
  YOU_ARE_NOT_ALLOWED_TO_LIST_USERS_SESSIONS: "Só administradores veem as sessões.",
};

// Desembrulha {data, error} do cliente; erro vira Error com mensagem em português.
export async function unwrap(promise) {
  let res;
  try {
    res = await promise;
  } catch {
    throw Object.assign(new Error("Sem conexão com o servidor."), { status: 0 });
  }
  if (res?.error) {
    const e = res.error;
    if (e.status === 429) throw Object.assign(new Error("Muitas tentativas. Espere um pouco e tente de novo."), { status: 429 });
    throw Object.assign(new Error(MESSAGES[e.code] || e.message || `Erro ${e.status}`), { status: e.status, code: e.code });
  }
  return res?.data;
}

// Token da sessão devolvido pelo Better Auth (corpo ou cabeçalho set-auth-token).
export const tokenOf = (data) => data?.token || data?.session?.token || null;
